import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiOutlineMail,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I am deeply passionate about Artificial Intelligence and have hands-on experience building
              end-to-end ML pipelines and intelligent systems.
              <br />
              <br />I am highly proficient in programming languages like
              <i>
                <b className="purple"> Python, JavaScript, and TypeScript. </b>
              </i>
              <br />
              <br />
              My primary fields of interest lie in &nbsp;
              <i>
                <b className="purple">Artificial Intelligence, Machine Learning, and NLP </b> and
                building robust <b className="purple">Multi-Agent Systems.</b>
              </i>
              <br />
              <br />
              Whenever possible, I apply my expertise to develop intelligent solutions
              using <b className="purple">Python-based Frameworks</b> like
              <i>
                <b className="purple"> CrewAI, FastAPI, and Flask</b>
              </i>
              &nbsp; as well as deploying scalable models with
              <i>
                <b className="purple"> AWS Lambda and Docker.</b>
              </i>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/deepti-50"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://x.com/DeeptiSingh50"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/deeptisingh18/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="mailto:deeptisunilsingh50@gmail.com"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiOutlineMail />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
